import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { ChevronRight, Lock, ShieldCheck } from "lucide-react";

export default function SubscriptionRequired() {
  const { user, logout } = useAuth();
  const [checkoutUrl, setCheckoutUrl] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/config/public");
        setCheckoutUrl(data?.eduzz_checkout_url || "");
      } catch { /* ok */ }
    })();
  }, []);

  const state = user?.access?.entitlement_state || null;
  const isLogged = Boolean(user);

  return (
    <main className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg card-soft p-8 text-center" data-testid="subscription-required-page">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FFF9ED] flex items-center justify-center">
          <Lock className="text-[#D9A441]" size={32} />
        </div>
        <h1 className="mt-5 text-3xl font-extrabold text-[#243B53]">Assinatura necessária</h1>
        <p className="mt-3 text-[#243B53]/75">
          Seu acesso ao Clubinho da Fé depende de uma assinatura ativa. Não temos plano
          gratuito — assine para receber histórias, jornadas, atividades e o Passaporte da Fé.
        </p>

        {isLogged && state && state !== "admin" && (
          <div className="mt-5 text-sm text-[#243B53]/70 bg-[#FFF9ED] rounded-2xl p-3" data-testid="entitlement-state">
            Status atual da sua assinatura: <b>{state}</b>
          </div>
        )}

        <div className="mt-7 flex flex-col gap-3">
          {checkoutUrl ? (
            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="subscription-cta-checkout"
              className="btn-primary inline-flex items-center justify-center gap-2"
            >
              Assinar o Clubinho — R$29,90/mês <ChevronRight size={18} />
            </a>
          ) : (
            <div className="text-sm text-red-600 font-bold" data-testid="checkout-missing">
              Checkout indisponível no momento. Tente novamente em instantes.
            </div>
          )}

          {!isLogged && (
            <Link
              to="/login"
              data-testid="subscription-login-link"
              className="btn-outline inline-flex items-center justify-center gap-2"
            >
              Já sou assinante — entrar
            </Link>
          )}

          {isLogged && (
            <button
              data-testid="subscription-logout-btn"
              onClick={logout}
              className="btn-outline inline-flex items-center justify-center gap-2"
            >
              Sair da conta
            </button>
          )}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-[#243B53]/60">
          <ShieldCheck size={14} /> Pagamento seguro processado pela Eduzz
        </div>
      </div>
    </main>
  );
}
